import { render } from "./StudentConf.vue?vue&type=template&id=44f89ffa&scoped=true"
import script from "./StudentConf.vue?vue&type=script&lang=js"
export * from "./StudentConf.vue?vue&type=script&lang=js"

import "./StudentConf.vue?vue&type=style&index=0&id=44f89ffa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f89ffa"]])

export default __exports__